// eslint-disable-next-line import/no-webpack-loader-syntax
import mapboxgl from '!mapbox-gl'; // https://docs.mapbox.com/mapbox-gl-js/guides/install/#excluding-mapbox-gl-js-explicitly-from-transpilation
import 'mapbox-gl/dist/mapbox-gl.css';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

export var mapboxToken = mapboxgl.accessToken;

const MAPBOX_DEFAULT_DARK_STYLE_ID = "cjs6ev22e0j5u1fnu2z4eg3mu";
const MAPBOX_DEFAULT_LIGHT_STYLE_ID = "cjrtvghfhkgwa2so1ig6w6h0a";

export default class MapboxHelper {

    static createMap(settings) {

        var themeUrl = settings.theme !== 'light' ? 'mapbox://styles/dan-in-ottawa/' + MAPBOX_DEFAULT_DARK_STYLE_ID : 'mapbox://styles/dan-in-ottawa/' + MAPBOX_DEFAULT_LIGHT_STYLE_ID;
        settings.style = themeUrl + "?optimize=true"; // RAV-3566 https://docs.mapbox.com/help/troubleshooting/mapbox-gl-js-performance/#remove-unused-features

        var map = new mapboxgl.Map({
            container: settings.container,
            style: settings.style,
            center: settings.center,
            zoom: settings.zoom,
        });

        var loadFunc = this.generateOnMapLoadedFunc(map, settings);

        map.on('load', loadFunc);

        return map;

    }

    static generateOnMapLoadedFunc(map, settings) {

        var me = this;

        return function () {

            // Initialize the map

            //add controls and modify settings
            var nav = new mapboxgl.NavigationControl();
            map.addControl(nav);
            map.scrollZoom.disable();//scrollzoom must disable then re-enable with different settings for new settings to work
            map.scrollZoom.enable({ around: 'center' });
            map.resize();

            // Callback into the owner's on load method

            me.initMapImages(map)
                .catch(error => console.error(error))
            // call onLoad anyway
                .then(() => settings.onLoad());
        };
    }

    // Load up all of the images that the map will use
    static initMapImages(map) {

        var imageLoader = (filename, imageName, extra = null) => {
            if(!map) return Promise.reject(Error('map is not'));
            return new Promise(function(resolve, reject) {
                map.loadImage(filename, (error, image) => {
                    if (error) reject(error);
                    else resolve(image);
                })
            }).then(image => {
                if(map.style)
                {
                    if(extra)
                        map.addImage(imageName, image, extra);
                    else
                        map.addImage(imageName, image);
                }
            });
        };

        return Promise.all([
            /* Start and end marker */
            imageLoader('/images/map-start-marker.png', 'start-marker'),
            imageLoader('/images/map-end-marker.png', "end-marker"),
            imageLoader('/images/map-marker-parked.png', "parked-marker"),

            /* Feature icons */
            imageLoader('/images/icon-map-feature.sdf', "map-feature", {sdf: true}),

            imageLoader('/images/fleet-map-marker_layer0_89.75-in-h91.png', "map-marker-layer0_background", {sdf: true}), // background circle
            imageLoader('/images/fleet-map-marker_layer1_89.75-in-h91.png', "map-marker-layer1_pin", {sdf: true}), // pin
            imageLoader('/images/fleet-map-marker_layer2_89.75-in-h91_parked.png', "map-marker-layer2_parked-icon"),
            imageLoader('/images/fleet-map-marker_layer2_89.75-in-h91.png', "map-marker-layer2_vehicle-icon"), // vehicle icon: basic truck
            imageLoader('/images/fleet-map-marker_layer2_89.75-in-h91-white.png', "map-marker-layer2_vehicle-icon-white"), // vehicle icon: basic truck
            imageLoader('/images/fleet-map-marker_layer2_car_89.75-in-h91.png', "map-marker-layer2_car-icon"), // vehicle icon: basic truck
            imageLoader('/images/fleet-map-marker_layer2_car_89.75-in-h91-white.png', "map-marker-layer2_car-icon-white"), // vehicle icon: basic truck
            imageLoader('/images/fleet-map-marker_layer3_89.75-in-h91.png', "map-marker-layer3_optional-badge"), // basic badge
        ]);

    }

}
